import gql from "graphql-tag";

const BLACKOUT_PERIOD_FIELDS = gql`
  fragment BlackoutPeriodFields on BlackoutPeriod {
    id
    installationId
    name
    reason
    startsAt
    endsAt
    startTime
    endTime
    isActive
  }
`;

export const blackoutPeriodsQuery = gql`
  query BlackoutPeriods($installationId: ID!, $includeInactive: Boolean) {
    blackoutPeriods(
      installationId: $installationId
      includeInactive: $includeInactive
    ) {
      ...BlackoutPeriodFields
    }
  }
  ${BLACKOUT_PERIOD_FIELDS}
`;

export const createBlackoutPeriodMutation = gql`
  mutation CreateBlackoutPeriod($period: BlackoutPeriodCreateInput!) {
    createBlackoutPeriod(period: $period) {
      ...BlackoutPeriodFields
    }
  }
  ${BLACKOUT_PERIOD_FIELDS}
`;

export const updateBlackoutPeriodMutation = gql`
  mutation UpdateBlackoutPeriod($period: BlackoutPeriodUpdateInput!) {
    updateBlackoutPeriod(period: $period) {
      ...BlackoutPeriodFields
    }
  }
  ${BLACKOUT_PERIOD_FIELDS}
`;

export const deleteBlackoutPeriodMutation = gql`
  mutation DeleteBlackoutPeriod($id: ID!) {
    deleteBlackoutPeriod(id: $id)
  }
`;
